module.exports = __webpack_public_path__ + "img/event_upcoming.ac0a921d.svg";